
import React from 'react';
import '../style.css';

export const Ediciones = () => {
    return (
        <div>Contenido de Ediciones</div>
    );
  };
  